var map = {
	"./agreement": [
		"lI5F",
		0,
		6
	],
	"./agreement/": [
		"lI5F",
		0,
		6
	],
	"./agreement/index": [
		"lI5F",
		0,
		6
	],
	"./agreement/index.vue": [
		"lI5F",
		0,
		6
	],
	"./charge": [
		"C0L3",
		1,
		0
	],
	"./charge/": [
		"C0L3",
		1,
		0
	],
	"./charge/error": [
		"pZ6w",
		9
	],
	"./charge/error.vue": [
		"pZ6w",
		9
	],
	"./charge/index": [
		"C0L3",
		1,
		0
	],
	"./charge/index.vue": [
		"C0L3",
		1,
		0
	],
	"./charge/login": [
		"rY0Z",
		8
	],
	"./charge/login.vue": [
		"rY0Z",
		8
	],
	"./chat": [
		"4USg",
		0,
		3
	],
	"./chat/": [
		"4USg",
		0,
		3
	],
	"./chat/addPopup": [
		"7mL8",
		0,
		12
	],
	"./chat/addPopup.vue": [
		"7mL8",
		0,
		12
	],
	"./chat/index": [
		"4USg",
		0,
		3
	],
	"./chat/index.vue": [
		"4USg",
		0,
		3
	],
	"./faq": [
		"MKaz",
		4
	],
	"./faq/": [
		"MKaz",
		4
	],
	"./faq/detail_popup": [
		"/t2N",
		10
	],
	"./faq/detail_popup.vue": [
		"/t2N",
		10
	],
	"./faq/index": [
		"MKaz",
		4
	],
	"./faq/index.vue": [
		"MKaz",
		4
	],
	"./feedback": [
		"AyAg",
		0,
		2
	],
	"./feedback/": [
		"AyAg",
		0,
		2
	],
	"./feedback/addPopup": [
		"p27b",
		0,
		11
	],
	"./feedback/addPopup.vue": [
		"p27b",
		0,
		11
	],
	"./feedback/index": [
		"AyAg",
		0,
		2
	],
	"./feedback/index.vue": [
		"AyAg",
		0,
		2
	],
	"./gameprompt": [
		"O4ev",
		5
	],
	"./gameprompt/": [
		"O4ev",
		5
	],
	"./gameprompt/index": [
		"O4ev",
		5
	],
	"./gameprompt/index.vue": [
		"O4ev",
		5
	],
	"./privacy": [
		"VKkN",
		0,
		7
	],
	"./privacy/": [
		"VKkN",
		0,
		7
	],
	"./privacy/index": [
		"VKkN",
		0,
		7
	],
	"./privacy/index.vue": [
		"VKkN",
		0,
		7
	],
	"./website/firehero": [
		"woKb"
	],
	"./website/firehero/": [
		"woKb"
	],
	"./website/firehero/h5": [
		"3CZ3"
	],
	"./website/firehero/h5.vue": [
		"3CZ3"
	],
	"./website/firehero/index": [
		"woKb"
	],
	"./website/firehero/index.vue": [
		"woKb"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5BXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*$
// module id = 5BXs
// module chunks = 13